<template>
    <div class="detail">
        <div v-show="showDel" class="del-wrap fixed">
            <div class="inner">
                <span>提示</span>
                <span class="tc w100">确定删除该条数据吗？请谨慎操作</span>
                <div>
                <span class="btn" @click="toDel">确定</span>
                <span class="btn" @click="cancel">取消</span>
                </div>
            </div>
        </div>
        <div class="inner">
            <span class="btn btn-add" @click="add">新增</span>
            <span class="btn btn-ensure" @click="ensure">确定</span>
            <span class="btn btn-cancel" @click="$emit('close')">取消</span>
            <span class="title">详情-{{data.name}}</span>
            <div class="info-item">
                <span>姓名：</span>
                <input type="text" placeholder="请输入姓名" v-model="info.name">
            </div>
            <div class="info-item">
                <span>地址：</span>
                <input type="text" placeholder="请输入地址" v-model="info.address">
            </div>
            <div class="info-item">
                <span>电话：</span>
                <input type="text" placeholder="请输入电话" v-model="info.phone">
            </div>
            <ListItem :isHead="true" :data="headOption"></ListItem>
            <div class="dia-wrap">
                <ListItem 
                    v-for="(item, index) in list"
                    :key="index"
                    :id="index"
                    @updateListItem="updateList($event, index)"
                    @onClick="onClick($event, index)"
                    :data="item"></ListItem>
            </div>
        </div>
    </div>
</template>

<script>
import ListItem from '@/components/ListItem.vue';
import { addRootItem, getNewItem, upgradeItem } from '@/utils/index';
export default {
    name: 'Detail',
    props: ['data'],
    components: {
        ListItem
    },
    data: function() {
        return {
            showDel: false,
            info: {
                name: '',
                phone: '',
                address: ''
            },
            headOption: {
                name: '日期',   // 姓名
                address: '单价',    // 地址
                phone: '吨数',  // 电话
                totalPrice: '金额', // 总价
                sended: '是否付款',
                tip: '操作'
            },
            list: [],
            delIndex: ''
        }
    },
    computed: {
        isNew() {
            return !this.data.id;
        }
    },
    watch: {
        data: {
            handler(val) {
                const { name, address, phone } = val;
                this.info = {name, address, phone};
                this.list = val.list || [];
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        add() {
            this.list.push(getNewItem());
        },
        onClick(type, index) {
            if(type =='del') {
                this.showDel = true;
                this.delIndex = index;
            }
        },
        cancel() {
            this.showDel = false;
        },
        toDel() {
            const data = this.data;
            data.list.splice(this.delIndex, 1);
            upgradeItem(data).then(() => {
                this.cancel();
                this.$emit('refresh');
            });
        },
        ensure() {
            const { name, phone, address } = this.info;
            if(this.isNew) {
                addRootItem({
                    name,
                    phone,
                    address,
                    list: this.list
                }).then(() => {
                    this.$emit('refresh');
                    this.$emit('close');
                    this.clearInfo();
                });
            } else {
                let data = this.data;
                data = Object.assign({}, data, {name, phone, address});
                upgradeItem(data).then(() => {
                    this.$emit('refresh');
                    this.$emit('close');
                });
            }
        },
        clearInfo() {
            this.info = {
                name: '',
                phone: '',
                address: ''
            }
        },
        updateList(item, index) {
            this.list[index] = item;
        }
    }
}
</script>

<style scoped>
.detail {
    position: fixed;
    left: 0;
    top: 0;
    padding: 100px;
    background: rgba(0, 0, 0, .5);
    z-index: 10;
    width: 100%;
    height: 100%;
}
.inner {
    width: 100%;
    height: 100%;
    background: #fff;
    position: relative;
    padding-bottom: 40px;
}
.btn-add {
    position: absolute;
    right: 40px;
    top: 10px;
}
.btn-ensure {
    position: absolute;
    left: 200px;
    width: 80px;
    text-align: center;
    bottom: 10px;
}
.btn-cancel {
    position: absolute;
    right: 200px;
    width: 80px;
    text-align: center;
    bottom: 10px;
}
.inner .title {
    width: 100%;
    text-align: center;
    height: 60px;
    line-height: 60px;
}
.info-item {
    width: 33%;
    display: inline-flex;
    align-items: center;
    padding-left: 20px;
    height: 40px;
    margin-bottom: 10px;
}
.info-item input {
    padding: 0 10px;
    border: 1px solid #eee;
    width: 150px;
    height: 32px;
}
.dia-wrap {
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
}

</style>